import axios from 'axios';
import api from './ApiAuthService';

export default class Classifieds {

  static async post(dados: any) {
    try {
      const response = await api.post("/posts/classifieds", dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async update(id: number, dados: any) {
    try {
      const response = await api.post(("/posts/classifieds/" + id ), dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}